import { sv as e, es as o, ptPT as s, ptBR as a, no as f, it as i, hu as p, de as c, frFR as d, frCA as l, fi as S, enUS as T, nl as R, da as u, hr as U } from "./highrise1301.mjs";
const r = {
  hr: U,
  da: u,
  nl: R,
  "en-US": T,
  fi: S,
  "fr-CA": l,
  "fr-FR": d,
  de: c,
  hu: p,
  it: i,
  no: f,
  "pt-BR": a,
  "pt-PT": s,
  es: o,
  sv: e
}, h = (t) => {
  const n = r[t];
  return n || r["en-US"];
};
export {
  h as createNonTranslatedStrings
};
